import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    number: "1",
    title: "Choose Your Vehicle Type",
    desc: "Start by selecting your preferred vehicle type — SUV, Sedan, Truck, or Van. This helps us match you with the best financing options available.",
  },
  {
    number: "2",
    title: "Submit Your Application",
    desc: "Fill out our quick and secure financing form. It takes less than 2 minutes and helps us understand your needs better.",
  },
  {
    number: "3",
    title: "Get Approved Fast",
    desc: "Our team reviews your details and connects you with the most competitive approval rates — even if your credit isn’t perfect.",
  },
  {
    number: "4",
    title: "Drive Away with Confidence",
    desc: "Once approved, choose your car and finalize your deal. You’ll be driving your new vehicle in as little as 48 hours.",
  },
];

const HowItWorks = () => {
  return (
    <section
      className="relative py-20 px-6 text-center overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #0b2545 0%, #0e7480 100%)",
      }}
    >
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-extrabold text-white mb-12 tracking-tight"
      >
        How Financing with Yes Auto Works
      </motion.h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl shadow-xl border border-white/20 hover:border-teal-300 transition-all duration-300"
          >
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-r from-teal-400 to-blue-500 text-white font-bold text-2xl shadow-lg border border-white/40">
                {step.number}
              </div>
            </div>
            <h3 className="text-2xl font-semibold text-white mb-3">
              {step.title}
            </h3>
            <p className="text-gray-200 leading-relaxed text-sm">{step.desc}</p>
          </motion.div>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.6 }}
        className="max-w-4xl mx-auto mt-16 text-gray-100 text-lg font-medium"
      >
        <strong>
          The entire process takes less than 2 minutes — with 95% approval
          success.
        </strong>{" "}
        No hidden fees, no pressure — just a smooth, transparent, and secure
        financing experience designed for Canadians.
      </motion.p>
    </section>
  );
};

export default HowItWorks;
